<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">

          <div class="card-header">
            <div class="row">
              <div class="col">
                <div class="pull-left">
                  <h4 class="card-title float-left">
                    {{ $t("fitment.plus.list") }}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">

            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group" v-if="fitment.hasCustomerClient">
                  <label>Буйюртмачи <span
                      class="red">*</span></label>
                  <v-select v-model="fitment.customerClient" label="text"
                            :options="customers"
                            :filterable="false"
                            @search="onCustomerSearch"
                            @search:focus="onCustomerFocus"
                            :class="{invalid : $v.fitment.customerClient.$error}">
                    <template slot="option" slot-scope="option" v-if="option && option.text">
                      <div v-html="option.text"></div>
                    </template>
                    <template slot="selected-option"
                              v-if="fitment && fitment.customerClient && fitment.customerClient.text">
                      <div v-html="fitment.customerClient.text"></div>
                    </template>
                    <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                  </v-select>
                  <div class="red" v-if="$v.fitment.customerClient.$error">
                    Буйюртмачи
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("common.evlPrice") }}</label>
                  <numeric-input class="form-control" v-model="fitment.evlPrice"
                                 :controls="false" :precision="2" :disabled="true"></numeric-input>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluationRespectiveType") }} <span
                          class="red">*</span></label>
                      <select class="form-control" v-model="fitment.evaluationRespectiveType"
                              :class="{invalid : $v.fitment.evaluationRespectiveType.$error}">
                        <option :value="option.code" v-for="option in evaluationRespectiveTypes"
                                :key="option.code">
                          {{ option.displayName }}
                        </option>
                      </select>
                      <div class="red" v-if="$v.fitment.evlGoalType.$error">
                        {{ $t("realEstate.validation.evaluationRespectiveType") }}
                      </div>
                    </div>
                    <div class="form-row" v-if="isTenders">
                      <div class="form-group col-md-6">
                        <label>{{ $t("realEstate.field.tenderContractDate") }} <span class="red">*</span></label>
                        <datepicker class="form-control" format="dd/MM/yyyy"
                                    v-model="tenderContractDate"
                                    :date="tenderContractDate"
                                    :clear-button="true"
                                    :class="{invalid:$v.tenderContractDate.$error}"></datepicker>
                        <div class="red" v-if="$v.tenderContractDate.$error">
                          {{ $t("realEstate.field.tenderContractDate") }}
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label>
                          {{ $t("realEstate.field.tenderContractNumber") }} <span class="red">*</span>
                        </label>
                        <input type="text" class="form-control"
                               :class="{invalid: $v.fitment.tenderContractNumber.$error}"
                               v-model="fitment.tenderContractNumber">
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.ownerClient") }} <span class="red">*</span></label>
                      <v-select v-model="fitment.ownerClient" label="text"
                                :options="owners"
                                :filterable="false"
                                @search="onOwnerSearch"
                                @search:focus="onOwnerFocus"
                                :class="{invalid : $v.fitment.ownerClient.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.ownerClient && fitment.ownerClient.text">
                          <div v-html="fitment.ownerClient.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.fitment.ownerClient.$error">
                        {{ $t("realEstate.validation.ownerClient") }}
                      </div>
                    </div>

                    <div class="form-group" v-if="fitment.hasCustomerClient">
                      <label>Ишончнома номери: <span class="red">*</span></label>
                      <input type="text" class="form-control" v-model="fitment.powerOfAttorneyNumber"
                             :class="{invalid : $v.fitment.powerOfAttorneyNumber.$error}"/>
                      <div class="red" v-if="$v.fitment.powerOfAttorneyNumber.$error">Ишончнома номери
                      </div>
                    </div>

                    <div class="form-group" v-if="fitment.hasCustomerClient">
                      <label>Ишончнома санаси: <span class="red">*</span></label>
                      <datepicker class="form-control" format="dd/MM/yyyy"
                                  v-model="powerOfAttorneyDate"
                                  :clear-button="true"
                                  :class="{invalid : $v.powerOfAttorneyDate.$error}"></datepicker>
                      <div class="red" v-if="$v.powerOfAttorneyDate.$error">Ишончнома санаси:
                      </div>
                    </div>

                    <template v-if="isOrgTypeMib">
                      <div class="form-group">
                        <label>{{ $t("realEstate.field.mibDebtorName") }} <span
                            class="red">*</span></label>
                        <input type="text" class="form-control" v-model="fitment.debtor"
                               :class="{invalid : $v.fitment.debtor.$error}"/>
                        <div class="red" v-if="$v.fitment.debtor.$error">
                          {{ $t("realEstate.validation.mibDebtorName") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>{{ $t("realEstate.field.mibLetterNumber") }} <span
                            class="red">*</span></label>
                        <input type="text" class="form-control" v-model="fitment.letterNumber"
                               :class="{invalid : $v.fitment.letterNumber.$error}"/>
                        <div class="red" v-if="$v.fitment.letterNumber.$error">
                          {{ $t("realEstate.validation.mibLetterNumber") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>{{ $t("realEstate.field.mibLetterDate") }} <span
                            class="red">*</span></label>
                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="contractDate"
                                    :clear-button="true"
                                    :class="{invalid : $v.contractDate.$error}"></datepicker>
                        <div class="red" v-if="$v.contractDate.$error">
                          {{ $t("realEstate.validation.mibLetterDate") }}
                        </div>
                      </div>
                    </template>

                  </div>


                  <div class="col-12 col-md-6">

                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluationPurpose") }} <span
                          class="red">*</span></label>
                      <select class="form-control" v-model="fitment.evlGoalType"
                              :class="{invalid : $v.fitment.evlGoalType.$error}">
                        <option :value="option.key" v-for="option in goalTypes" :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                      <div class="red" v-if="$v.fitment.evlGoalType.$error">
                        {{ $t("realEstate.validation.evaluationPurpose") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluator") }} <span class="red">*</span></label>
                      <v-select v-model="fitment.employee" label="text"
                                :options="employees"
                                :filterable="false"
                                @search="onEmployeeSearch"
                                @search:focus="onEmployeeFocus"
                                :class="{invalid : $v.fitment.employee.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.employee && fitment.employee.text">
                          <div v-html="fitment.employee.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.fitment.employee.$error">
                        {{ $t("realEstate.validation.evaluator") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("realEstate.field.contractAmount") }}</label>
                      <numeric-input class="form-control" v-model="fitment.evlContractAmount"
                                     :controls="false" :precision="2"></numeric-input>

                    </div>
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.propertyType") }} <span class="red">*</span></label>
                      <select class="form-control" v-model="fitment.evlPropertyType"
                              :class="{invalid : $v.fitment.evlPropertyType.$error}">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                      <div class="red" v-if="$v.fitment.evlPropertyType.$error">
                        {{ $t("realEstate.validation.propertyType") }}
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <div class="col-12 col-md-6">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                      v-model="selectedFitmentDocsTab"
                      :options="[
                                { text: 'Ижро варакаси', value: 'docs' },
                                { text: 'мурожат хати', value: 'docs' },
                                { text: 'Акт', value: 'docs' },
                                { text: 'Карор', value: 'docs' }
                                ]"
                      :aria-describedby="ariaDescribedby"
                      button-variant="form-radio-group"
                      name="radio-btn-outline1"
                      buttons
                  ></b-form-radio-group>
                </b-form-group>

                <div class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in fitment.letterFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>

                <div class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in fitment.actOfSaleFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
                <div class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in fitment.decisionFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
                <div class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in fitment.executivePlaylistFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-12">
                <div class="section-header font-weight-bold colllapse-header">
                  <div block v-b-toggle.approach-cost v-tooltip="$t('fitment.label')">
                    <h4>
                      {{ $t("fitment.list") }}
                    </h4>
                  </div>
                </div>
                <div class="row" v-if="fitment.id && fitment.id > 0">
                  <div class="col-md-8">
                    <div class="form-group" v-if="fitment.approachCost">
                      <label>{{ $t("realEstate.field.cadastreSection") }} <span class="red">*</span></label>
                      <div class="row">
                        <div class="col-md-12">

                        </div>
                      </div>
                    </div>
                  </div>

                  <!--                  <div class="col-12">-->

                  <!--                    <section v-for="(item, index) in fitment.evaluationFitments" :key="item.id">-->
                  <!--                      <div class="row">-->
                  <!--                        <div class="col-12">-->
                  <!--                          <button type="button"-->
                  <!--                                  v-tooltip="'ўчириш'"-->
                  <!--                                  class="all-btn delete-btn btn-sm float-right mr-3"-->
                  <!--                                  @click="showDeleteFitmentDialog(item, index)"-->
                  <!--                          >-->
                  <!--                            <i class="fa fa-trash-o"></i>-->
                  <!--                          </button>-->
                  <!--                        </div>-->
                  <!--                        <div class="col-12">-->
                  <!--                          <FitmentItemPlusComplement-->
                  <!--                              :itemId="item.id"-->
                  <!--                              :index="index"-->
                  <!--                              :parentId="fitment.id"-->
                  <!--                              :appraisalStatusEnum="fitment.appraisalStatusEnum"-->
                  <!--                              :objectType="fitment.entiteCreateType"-->
                  <!--                              :ref="`childItem-${index}`"-->
                  <!--                              :isRemoveFile="canRemoveFile"-->
                  <!--                              :isEditableFile="canSave"-->
                  <!--                          />-->
                  <!--                        </div>-->

                  <!--                      </div>-->
                  <!--                    </section>-->
                  <!--                  </div>-->

                  <div class="col-md-4">
                    <button class="all-btn btn-sm add-btn pull-right mr-3"
                            v-tooltip="$t('realEstate.field.addBuilding')" @click="addFitments">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div class="col-12">

                    <section v-for="(item, index) in fitment.evaluationFitments" :key="item.id">
                      <div class="row">
                        <div class="col-12">
                          <!--                                                  <button type="button"-->
                          <!--                                                          class="all-btn add-btn btn-sm float-right mr-3"-->
                          <!--                                                          @click="saveItem(item, index)">-->
                          <!--                                                    {{ $t("action.save") }}-->
                          <!--                                                    <i class="fa fa-save"></i>-->
                          <!--                                                  </button>-->
                          <button type="button"
                                  class="all-btn delete-btn btn-sm float-right mr-3"
                                  @click="showDeleteFitmentItemDialog(item, index)">
                            {{ $t("action.delete") }}
                            <i class="fa fa-trash-o"></i>
                          </button>
                        </div>
                        <div class="col-12">

                          <div role="tablist">

                            <div class="card">
                              <div class="card-header bg-light">
                                <div class="row">
                                  <div class="col-12 col-md-4" v-b-toggle="'collapse'+index" style="cursor: pointer"
                                       v-tooltip="'Маълумотларни очиш'">
                                    <span><i class="fa fa-arrow-down"></i><b>№{{ index + 1 }}.(#id:{{
                                        item.id
                                      }})</b></span>
                                  </div>
                                  <div class="col-12 col-md-6">
                                    <span><b>{{ item.name }}</b></span>
                                  </div>


                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <hr/>
                                  </div>
                                </div>

                              </div>

                              <b-collapse :id="'collapse'+index" accordion="my-accordion" role="tabpanel">
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col-12 col-md-6">

                                      <div class="form-group">
                                        <label :class="$v.fitment.evaluationFitments.$each[index].province.$error ? 'red' : ''">
                                          {{$t('client.field.province')}}<span class="red">*</span></label>

                                        <v-select
                                            label="name"
                                            v-model="item.province"
                                            :filterable="false"
                                            :options="provinces"
                                            @search="onProvinceSearch"
                                            @search:focus="onProvinceFocus"
                                            @change="onChangeFilterProvince"
                                        >
                                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                      </div>

                                      <div class="form-group">
                                        <label
                                            :class="$v.fitment.evaluationFitments.$each[index].productCategoryPlusDto.$error ? 'red' : ''">
                                          {{ $t('config.products.productCategory.title') }}<span
                                            class="red">*</span></label>
                                        <v-select v-model="item.productCategoryPlusDto" label="name"
                                                  :class="{invalid : $v.fitment.evaluationFitments.$each[index].productCategoryPlusDto.$error}"
                                                  :options="productCategories"
                                                  :filterable="false"
                                                  @search="onCategorySearch"
                                                  @search:focus="onCategoryFocus">
                                          <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                          </template>
                                          <template slot="selected-option"
                                                    v-if="item.productCategoryPlusDto && item.productCategoryPlusDto && item.productCategoryPlusDto.name">
                                            <div v-html="item.productCategoryPlusDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                          </template>
                                          <span slot="no-options">{{ $t("empty") }}</span>
                                        </v-select>
                                      </div>

                                      <div class="form-group">
                                        <label
                                            :class="$v.fitment.evaluationFitments.$each[index].productManufactureDto.$error ? 'red' : ''">
                                          {{ $t('config.products.productManufacture.title') }}<span
                                            class="red">*</span></label>
                                        <v-select v-model="item.productManufactureDto" label="name"
                                                  :class="{invalid : $v.fitment.evaluationFitments.$each[index].productManufactureDto.$error}"
                                                  :options="manufactures"
                                                  :filterable="false"
                                                  @search="onProductManufactureSearch(index)"
                                                  @search:focus="onProductManufactureFocus(index)">
                                          <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                          </template>
                                          <template slot="selected-option"
                                                    v-if="item && item.productManufactureDto && item.productManufactureDto.name">
                                            <div v-html="item.productManufactureDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                          </template>
                                          <span slot="no-options">{{ $t("empty") }}</span>
                                        </v-select>
                                      </div>

                                      <div class="form-group">

                                        <label
                                            :class="$v.fitment.evaluationFitments.$each[index].countryDto.$error ? 'red' : ''">
                                          {{
                                            item.fitmentType === 'JEWELRY' ? 'Заргарлик буйум ишлаб чиққарилган мамлакат' : $t("fitment.madeCountry")
                                          }} <span class="red">*</span></label>
                                        <v-select v-model="item.countryDto" label="name"
                                                  :options="countryList"
                                                  :filterable="false"
                                                  @search="onCountrySearch"
                                                  @search:focus="onCountryFocus"
                                                  :class="{invalid : $v.fitment.evaluationFitments.$each[index].countryDto.$error}">
                                          <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                          </template>
                                          <template slot="selected-option"
                                                    v-if="item && item.countryDto && item.countryDto.name">
                                            <div v-html="item.countryDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                          </template>
                                          <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                                        </v-select>
                                      </div>

                                      <div class="form-group"
                                           v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                        <label
                                            :class="$v.fitment.evaluationFitments.$each[index].overlayCoefficient.$error ? 'red' : ''">
                                          {{ $t("fitment.overlayCoefficient") }} <span class="red">*</span></label>
                                        <numeric-input class="form-control"
                                                       :class="{invalid : $v.fitment.evaluationFitments.$each[index].overlayCoefficient.$error}"
                                                       v-model="item.overlayCoefficient"
                                                       :controls="false" :precision="3"></numeric-input>
                                      </div>

                                    </div>

                                    <div class="col-12 col-md-6">

                                      <div class="form-group">
                                        <label :class="!$v.fitment.evaluationFitments.$each[index].address.$error ? 'red' : ''">
                                          {{ $t("fitment.address") }} <span class="red">*</span></label>

                                        <input type="text" class="form-control" v-model="item.address"
                                               :class="{invalid : $v.fitment.evaluationFitments.$each[index].address.$error}"/>
                                      </div>

                                      <div class="form-group">
                                        <label
                                            :class="$v.fitment.evaluationFitments.$each[index].productSubCategoryPlusDto.$error ? 'red' : ''">
                                          {{ $t('config.products.productSubCategory.title') }}<span
                                            class="red">*</span></label>
                                        <v-select v-model="item.productSubCategoryPlusDto" label="name"
                                                  :class="{invalid : $v.fitment.evaluationFitments.$each[index].productSubCategoryPlusDto.$error}"
                                                  :options="productSubCategories"
                                                  :filterable="false"
                                                  @search="onSubCategorySearch(index)"
                                                  @search:focus="onSubCategoryFocus(index)"
                                                  @input="onChangeMethodSub(index)">
                                          <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                          </template>
                                          <template slot="selected-option"
                                                    v-if="item && item.productSubCategoryPlusDto && item.productSubCategoryPlusDto.name">
                                            <div v-html="item.productSubCategoryPlusDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                          </template>
                                          <span slot="no-options">{{ $t("empty") }}</span>
                                        </v-select>
                                      </div>

                                      <div class="form-group">
                                        <label
                                            :class="$v.fitment.evaluationFitments.$each[index].productModelDto.$error ? 'red' : ''">
                                          {{ $t('config.products.productModel.title') }}<span
                                            class="red">*</span></label>
                                        <v-select v-model="item.productModelDto" label="name"
                                                  :class="{invalid : $v.fitment.evaluationFitments.$each[index].productModelDto.$error}"
                                                  :options="productModels"
                                                  :filterable="false"
                                                  @search="onProductModelSearch(index)"
                                                  @search:focus="onProductModelFocus(index)">
                                          <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                          </template>
                                          <template slot="selected-option"
                                                    v-if="item && item.productModelDto && item.productModelDto.name">
                                            <div v-html="item.productModelDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                          </template>
                                          <span slot="no-options">{{ $t("empty") }}</span>
                                        </v-select>
                                      </div>

                                      <div class="form-group"
                                           v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                        <label
                                            :class="!$v.fitment.evaluationFitments.$each[index].stoneName.$error ? 'red' : ''">
                                          {{ $t("fitment.stoneName") }} </label>
                                        <input type="text" class="form-control"
                                               :class="{invalid : $v.fitment.evaluationFitments.$each[index].stoneName.$error}"
                                               v-model="item.stoneName"/>
                                      </div>

                                      <div class="form-group">
                                        <div class="row">
                                          <div class="col-md-6 col-6">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].qty.$error ? 'red' : ''">
                                              {{ $t("fitment.qty") }} <span class="red">*</span></label>
                                            <numeric-input class="form-control" v-model="item.qty"
                                                           :class="{invalid : $v.fitment.evaluationFitments.$each[index].qty.$error}"
                                                           :controls="false" :precision="3"></numeric-input>
                                          </div>

                                          <div class="col-md-6 col-6">
                                            <label>
                                              Ўлчов бирликлари
                                            </label>
                                            <MeasurementTypeSelect :value="item.um"
                                                                   v-model="item.um"></MeasurementTypeSelect>
                                          </div>

                                          <div class="col-md-5 col-6"
                                               v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                            <label
                                                :class="!$v.fitment.evaluationFitments.$each[index].weigh.$error ? 'red' : ''">
                                              {{ $t("fitment.weigh") }}
                                              <span class="red">*</span>
                                            </label>
                                            <numeric-input class="form-control" v-model="item.weigh"
                                                           :class="{invalid : $v.fitment.evaluationFitments.$each[index].weigh.$error}"
                                                           :controls="false" :precision="3"></numeric-input>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="form-group"
                                           v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                        <div class="row">
                                          <div class="col-md-7 col-6">
                                            <label
                                                :class="!$v.fitment.evaluationFitments.$each[index].metalType.$error ? 'red' : ''">
                                              {{ $t("fitment.metalType") }}
                                              <span class="red">*</span>
                                            </label>
                                            <select class="form-control"
                                                    :class="{invalid : $v.fitment.evaluationFitments.$each[index].metalType.$error}"
                                                    v-model="item.metalType">
                                              <option value="GOLD">{{ $t("fitment.gold") }}</option>
                                              <option value="SILVER">{{ $t("fitment.silver") }}</option>
                                            </select>
                                          </div>
                                          <div class="col-md-5 col-6"
                                               v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                            <label
                                                :class="!$v.fitment.evaluationFitments.$each[index].hallmark.$error ? 'red' : ''">
                                              {{ $t("fitment.hallmark") }} <span class="red">*</span></label>
                                            <numeric-input class="form-control" v-model="item.hallmark"
                                                           :class="{invalid : $v.fitment.evaluationFitments.$each[index].hallmark.$error}"
                                                           :controls="false" :precision="3"></numeric-input>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="form-group"
                                           v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                        <label
                                            :class="!$v.fitment.evaluationFitments.$each[index].stonePrice.$error ? 'red' : ''">
                                          {{ $t("fitment.stonePrice") }} <span class="red">*</span></label>
                                        <numeric-input class="form-control" v-model="item.stonePrice"
                                                       :class="{invalid : $v.fitment.evaluationFitments.$each[index].stonePrice.$error}"
                                                       :controls="false" :precision="0"></numeric-input>
                                      </div>

                                    </div>

                                  </div>
                                </div>
                              </b-collapse>

                            </div>
                          </div>
                        </div>

                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12"></div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12 btns-box">
              <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                {{ $t("action.cancel") }}
              </button>
              <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing">
                {{ $t("action.save") }}
              </button>

              <button class="all-btn delete-btn" @click="deleteFitment(fitment)"
                      v-if="hasPermission('NEW_FITMENT_DELETE')">
                {{ $t("realEstate.delete.title") }}
              </button>

<!--              <button class="all-btn ml-3"-->
<!--                      :disabled="processing"-->
<!--                      @click="sendingToAgent">-->
<!--                {{ $t('main.send') }}-->
<!--              </button>-->

              <button class="all-btn add-btn"
                      @click="sendEvaluationObjectToIdentification(fitment)" :disabled="processing"
                      v-if="canInIdentification">
                Идентификацияга бериш
              </button>
              <button class="all-btn delete-btn" v-if="canReject" @click="rejectOrder">
                <i class="fa fa-reply-all"></i>
                <span>Рад қилиш</span>
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
    <RejectComment/>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {numericTypes} from '@/shared/constants/mask'
import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
import initFilterModel from '@/shared/filter';
import AssetDropZone from '@/views/asset/AssetDropZone'
import {required, requiredUnless, minLength, minValue} from 'vuelidate/lib/validators';
import {formatDate, parseDate} from '@/shared/utils';
import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
import FitmentStatusView from '@/views/fitment/FitmentStatusView.vue'
import FitmentHistoryView from '@/views/fitment/FitmentHistoryView.vue'
import RejectComment from '@/components/RejectComment';
import InnerImageZoom from 'vue-inner-image-zoom';
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import {BFormRadioGroup} from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {BFormGroup} from 'bootstrap-vue/es/components/form-group/form-group'
import FitmentItemPlusComplement from "../plus/FitmentItemPlusComplement";
import {UNIT_MEASUREMENT} from "@/shared/constants/fitment";
import MeasurementTypeSelect from '@/components/MeasurementTypeSelect';
// import Treeselect from '@riophae/vue-treeselect';

export default {
  name: "fitment-add-edit",
  components: {
    AssetDropZone,
    Datepicker,
    PreviewDropZone,
    FitmentStatusView,
    FitmentHistoryView,
    RejectComment,
    BCollapse,
    BFormGroup,
    BFormRadioGroup,
    InnerImageZoom,
    FitmentItemPlusComplement,
    MeasurementTypeSelect
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      processing: false,
      loading: {
        isDocQrLoading: false,
        isDocLoading: false,
        isPdfLoading: false,
        isPdfQrLoading: false,
        isCDocLoading: false,
        isCPdfLoading: false,
        isCDocQrLoading: false,
        isCPdfQrLoading: false,
        isDocNotSignedAndQRCodeLoading: false,
        isPdfNotSignedAndQRCodeLoading: false
      },
      show: false,
      isPageLoadInit: false,
      isAddValueCollapse: false,
      numericTypes: numericTypes,
      ownerFilter: initFilterModel(),
      customerFilter: initFilterModel(),
      employeeFilter: initFilterModel(),
      productCategoryFilter: initFilterModel(),
      subCategoryFilter: initFilterModel(),
      productManufactureFilter: initFilterModel(),
      productModelFilter: initFilterModel(),
      filterProvince: initFilterModel(),
      filter: initFilterModel(),
      selectedFitmentDocsTab: "images",
      prev: '<i class="material-icons">keyboard_arrow_left</i>',
      next: '<i class="material-icons">keyboard_arrow_right</i>',
      letterAllFiles: [],
      actOfSaleAllFiles: [],
      decisionAllFiles: [],
      executivePlaylistAllFiles: [],
      provinces: [],
      fitment: {
        id: null,
        ownerClient: {},
        evlObjectType: 'Fitment',
        evlGoalType: null,
        evlContractAmount: 0,
        prepayment: 0,
        employee: {},
        evlValueType: 'Market',
        evlPropertyType: '',
        province: '',
        address: '',
        debtor: '',
        letterNumber: null,
        contractDate: null,
        displayReport: false,
        hasCustomerClient: false,
        customerClient: null,
        powerOfAttorneyDate: null,
        powerOfAttorneyNumber: null,
        evaluationFitments: [
          {
            productCategoryPlusDto: {},
            productSubCategoryPlusDto: {},
            productManufactureDto: {},
            productModelDto: {},
            fitmentType: null,
            metalType: null,
            qty: 0,
            stonePrice: null,
            hallmark: null,
            weigh: null,
            overlayCoefficient: null,
            countryDto: null
          },
        ],

        letterFiles: [],
        actOfSaleFiles: [],
        decisionFiles: [],
        executivePlaylistFiles: [],
        checkPaymentFiles: [],// to'lov haqidagi hujjatlar
        appraisalStatusEnum: null,
        evaluationRespectiveType: "OTHER",
        tenderContractDate: null,
        tenderContractNumber: null,
        evaluatorIdea: '',
        evaluatorRestrictiveTerms: ''
      },
      tenderContractDate: null,
      contractDate: null,
      powerOfAttorneyDate: null,
      owners: [],
      customers: [],
      employees: [],
      manufactures: [],
      productCategories: [],
      productSubCategories: [],
      productModels: [],
      countryList: [],
      goalTypes: EVL_GOAL_TYPES,
      propertyTypes: EVL_PROPERTY_TYPES,
      unitMeasurements: UNIT_MEASUREMENT,
      evaluationRespectiveTypes: [],
      status: null,
      isDirector: false,
      isAppraiser: false
    }
  },
  validations() {
    return {
      fitment: {
        ownerClient: {
          required: required
        },
        customerClient: {
          required: requiredUnless(() => {
            return !(this.fitment.hasCustomerClient);
          })
        },
        powerOfAttorneyNumber: {
          required: requiredUnless(() => {
            return !(this.fitment.hasCustomerClient);
          })
        },
        evlGoalType: {
          required: required
        },
        evlPropertyType: {
          required: required
        },
        employee: {
          id: {
            required: required
          }
        },
        letterFiles: {
          required: requiredUnless(() => {
            return !this.isMib;
          }),
          minLength: minLength(1)
        },
        actOfSaleFiles: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          }),
          minLength: minLength(1)
        },
        decisionFiles: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          }),
          minLength: minLength(1)
        },
        // MIB
        debtor: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          })
        },
        letterNumber: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          })
        },
        evaluationRespectiveType: {
          required: required
        },
        tenderContractNumber: {
          required: requiredUnless(() => {
            return !this.isTenders;
          })
        },
        evaluationFitments: {
          $each: {

            productCategoryPlusDto: {
              id: {
                required: required
              }
            },
            productSubCategoryPlusDto: {
              id: {
                required: required
              }
            },
            productManufactureDto: {
              id: {
                required: required
              }
            },
            productModelDto: {
              id: {
                required: required
              }
            },
            countryDto: {
              id: {
                required: required
              }
            },
            address: {
              required: required
            },
            province: {
              id: {
                required: required
              }
            },
            qty: {
              required: requiredUnless(() => {
                return (this.entiteCreateType === 'EXPERT2') && minValue(1);
              }),
            },
            hallmark: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            weigh: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            stoneName: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            metalType: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            stonePrice: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            overlayCoefficient: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            }
          }
        }
      },
      contractDate: {
        required: requiredUnless(() => {
          return !this.isOrgTypeMib;
        })
      },
      tenderContractDate: {
        required: requiredUnless(() => {
          return !this.isTenders;
        })
      },
      powerOfAttorneyDate: {
        required: requiredUnless(() => {
          return !(this.fitment.hasCustomerClient);
        })
      }
    };
  },
  computed: {
    isOwnerTypePhysical() {
      return !!(this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Physical');
    },
    isOwnerTypeLegal() {
      return !!(this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Legal');
    },
    isMib() {
      return !!(this.fitment.ownerClient && this.fitment.ownerClient.organizationType && this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');

    },
    isOrgType() {
      return !!(this.fitment.ownerClient &&
          this.fitment.ownerClient.organizationType &&
          (this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION'));
    },

    isOrgTypeMib() {
      return !!(this.fitment.ownerClient &&
          this.fitment.ownerClient.organizationType &&
          (this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.fitment.ownerClient.organizationType === 'CUSTOMS_ADMINISTRATION'));
    },
    documentOrPassportLbl() {
      if (this.fitment) {
        if (this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Legal')
          return "asset.document";
        else
          return "asset.passport";
      } else {
        return "asset.passport";
      }
    },

    canSave() {
      // console.log("this.fitment =  ==", this.fitment)
      // console.log(
      //     this.fitment.entiteCreateType === 'API_EXARID' && !this.fitment.appraisalStatusEnum ||
      //     this.fitment.appraisalStatusEnum === 'Unreviewed' || this.fitment.appraisalStatusEnum === 'NotFullyEvaluated'
      //     | this.fitment.appraisalStatusEnum === 'SentToComplement'
      // )
      // return (this.fitment.entiteCreateType === 'API_EXARID' && !this.fitment.appraisalStatusEnum || this.fitment.appraisalStatusEnum === 'Unreviewed'
      //     || this.fitment.appraisalStatusEnum === 'NotFullyEvaluated' || this.fitment.appraisalStatusEnum === 'SentToComplement');
      return true;
    },

    checkPaymentLbl() {
      return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
    },
    canReject() {
      return this.hasPermission('NEW_FITMENT_EDIT');
    },
    canRemoveFile() {
      return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status !== 'Rejected' && this.hasPermission('NEW_FITMENT_IMAGE_DELETE')
    },
    canSendAgent() {
      return !this.fitment.appraisalStatusEnum && this.hasPermission('NEW_FITMENT_EDIT')
    },
    isTenders() {
      return this.fitment.evaluationRespectiveType === 'TENDERS';
    },
    canInIdentification() {
      return this.fitment.appraisalStatusEnum === 'SentToComplement' && this.hasPermission('NEW_FITMENT_EDIT');
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;

      const promises = [];
      if (id && id > 0) {
        vm.isPageLoadInit = true;
        promises.push(this.$http.get('fitment/' + id));

        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const editData = values[0].data;
            if (!editData.evlGoalType) {
              editData.evlGoalType = '';
            }
            vm.contractDate = parseDate(editData.contractDate);
            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
            vm.tenderContractDate = parseDate(editData.tenderContractDate);
            vm.fitment = editData;

            vm.fitment.employee = {};
            if (editData.employeeId && editData.employeeName) {
              vm.fitment.employee.id = editData.employeeId;
              vm.fitment.employee.text = editData.employeeName;
            }

            vm.fitment.actOfSaleFiles.forEach((file) => {
              vm.actOfSaleAllFiles.push(file);
            });
            vm.fitment.decisionFiles.forEach((file) => {
              vm.decisionAllFiles.push(file);
            });
            vm.fitment.letterFiles.forEach((file) => {
              vm.letterAllFiles.push(file);
            });
            vm.fitment.executivePlaylistFiles.forEach((file) => {
              vm.executivePlaylistAllFiles.push(file);
            });

            vm.status = editData.appraisalStatusEnum;
            vm.isPageLoadInit = false;

          }
        });
      }
    },
    cancel() {
      this.$router.push('/fitment/list');
    },
    save() {
      this.saveAndComplement();
    },

    saveAndComplement() {

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (this.region) {
        this.fitment.regionDto = this.region
      }

      console.log("this.fitment = ", this.fitment)

      if (this.fitment.prepayment && !(this.fitment.prepayment >= 0 && this.fitment.prepayment <= 100)) {
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
          type: 'warning'
        });
        return;
      }

      this.processing = true;

      if (this.contractDate) {
        this.fitment.contractDate = formatDate(this.contractDate);
      }

      if (this.tenderContractDate) {
        this.fitment.tenderContractDate = formatDate(this.tenderContractDate);
      }

      if (this.powerOfAttorneyDate) {
        this.fitment.powerOfAttorneyDate = formatDate(this.powerOfAttorneyDate);
      }

      if (this.fitment.employee) {
        this.fitment.employeeId = this.fitment.employee.id;
      }

      if (this.isMib) {
        this.fitment.evlContractAmount = 0;
      }
      this.$http.post('fitment/plus/complement/save', this.fitment)
          .then(res => {

            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.statusSuccess'),
                type: 'success'
              });
              this.$router.push('/fitment/plus/complement/' + res.data.data.id);
              this.editFitment(res.data.data.id);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.realEstate.statusWarning'),
                type: 'warning'
              });
            }
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },

    editFitment(id) {
      const vm = this;
      const promises = [];
      if (id && id > 0) {
        promises.push(this.$http.get('fitment/' + id));
        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const editData = values[0].data;
            if (!editData.evlGoalType) {
              editData.evlGoalType = '';
            }
            vm.contractDate = parseDate(editData.contractDate);
            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
            vm.fitment = editData;
            vm.fitment.employee = {};
            if (editData.employeeId && editData.employeeName) {
              vm.fitment.employee.id = editData.employeeId;
              vm.fitment.employee.text = editData.employeeName;
            }
          }
        });
      }
    },

    addEditPushItem(itemId, fitmentId) {
      this.$router.push({
        path: '/fitment/item/edit/' + itemId + '/' + fitmentId,
        query: {entiteCreateType: this.fitment.entiteCreateType}
      });
    },
    addFitment() {
      this.$router.push({
        path: '/fitment/item/new/' + this.fitment.id,
        query: {entiteCreateType: this.fitment.entiteCreateType}
      });
    },
    onOwnerSearch(searchTxt, loading) {
      loading(true);
      this.owners = [];
      this.ownerFilter.search = searchTxt;
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onOwnerFocus() {
      this.owners = [];
      this.ownerFilter.search = '';
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCustomerSearch(searchTxt, loading) {
      loading(true);
      this.customers = [];
      this.customerFilter.search = searchTxt;
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onCustomerFocus() {
      this.customers = [];
      this.customerFilter.search = '';
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onEmployeeSearch(searchTxt, loading) {
      loading(true);
      this.employees = [];
      this.employeeFilter.search = searchTxt;
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onEmployeeFocus() {
      this.employees = [];
      this.employeeFilter.search = '';
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onChangeEmployee() {
      if (this.fitment.employee) {
        this.fitment.employeeId = this.fitment.employee.id
      }
    },
    showDeleteFitmentItemDialog(item, index) {
      if (!item.id) {
        this.fitment.evaluationFitments.splice(index, 1);
      } else {
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: this.$t('asset.deleteConfirm'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#dd3333',
          confirmButtonText: 'Ўчириш',
          cancelButtonText: 'Бекор қилиш'
        }).then((result) => {
          if (result.value) {
            this.$http.delete('fitment/item/delete/' + item.id)
                .then((res) => {
                  if (res && res.data && res.data.status === 'SUCCESS') {
                    this.$swal({
                      title: this.$t('messages.common.success'),
                      text: this.$t('messages.building.deleteSuccess'),
                      type: 'success'
                    });
                    this.fitment.evaluationFitments.splice(index, 1);
                  } else {
                    this.$swal({
                      title: this.$t('messages.common.warning'),
                      text: res.data.message,
                      type: 'warning'
                    });
                  }
                  this.processing = false;
                }, () => {
                  this.$swal({
                    title: this.$t('messages.common.error'),
                    text: this.$t('messages.building.deleteError'),
                    type: 'error'
                  });
                  this.processing = false;
                });
          }
        });
      }
    },
    sendChangesToServer(status) {
      this.$http.post('change/status', {
        id: this.fitment.id,
        appraisalStatusEnum: status,
      }).then(res => {
        if (res && res.data) {
          if (res.data.status === 'SUCCESS') {
            this.$swal({
              title: this.$t('messages.common.success'),
              text: this.$t('asset.statusSuccess'),
              type: 'success'
            });
            this.fitment.appraisalStatusEnum = status;
            this.status = status;
            if (status === 'Confirmed') {
              if (this.fitment.hasEsp) {
                this.openSignPageDirector(this.fitment);
              }
            } else if (status === 'Rated') {
              if (this.fitment.hasEsp) {
                this.openSignPageAppraiser(this.fitment);
              }
            } else if (status === 'Unreviewed') {
              window.location.reload();
            }

          } else if (res.data.status === 'ERROR') {
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: res.data.message,
              type: 'warning'
            });
          }
        } else {
          this.$swal({
            title: this.$t('messages.common.warning'),
            text: this.$t('asset.statusWarning'),
            type: 'warning'
          });
        }
        this.processing = false;
        this.isPageLoadInit = false;
      }, () => {
        this.$swal({
          title: this.$t('messages.common.error'),
          text: this.$t('asset.statusError'),
          type: 'error'
        });
        this.processing = false;
        this.isPageLoadInit = false;
      });
    },
    getEvaluationRespectiveType() {
      this.$http.get('/evaluationRespectiveType').then(response => {
        this.evaluationRespectiveTypes = response.data;
      }, err => {
        console.log(err)
      });
    },
    deleteFitment: function (fitment) {
      this.processing = true;
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('fitment.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('delete/appraisal/' + fitment.id)
              .then((res) => {
                console.log(res.data);
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('fitment.deleteSuccess'),
                    type: 'success'
                  });
                  this.$router.push('/fitment/list');
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('fitment.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        } else {
          this.processing = false;
        }
      });
    },
    rejectOrder() {
      this.$eventBus.$emit('RejectComment', this.fitment.id, false, "Fitment");
    },
    isRoleDirector() {
      const authorities = this.$store.state.profile.authorities;
      for (const role of authorities) {
        if (role == "ROLE_DIRECTOR") {
          return this.isDirector = true;
        }

      }
    },
    isRoleAppraiser() {
      const authorities = this.$store.state.profile.authorities;
      for (const role of authorities) {
        if (role == "ROLE_APPRAISER") {
          return this.isAppraiser = true;
        }
      }
    },
    // sendingToAgent() {
    //   this.processing = true;
    //   this.isPageLoadInit = true;
    //   this.$http.get('/fitment/send-agent/' + this.fitment.id).then(response => {
    //     this.$swal({
    //       title: this.$t('messages.common.success'),
    //       text: response.data.message,
    //       type: 'success'
    //     });
    //     this.processing = false;
    //   }).catch(err => {
    //     console.log(err);
    //     this.$swal({
    //       title: this.$t('messages.common.warning'),
    //       text: this.$t('messages.common.error'),
    //       type: 'warning'
    //     });
    //     this.processing = false;
    //   });
    // },

    sendEvaluationObjectToIdentification: function (fitment) {
      this.processing = true;
      this.$http.get('/auto/send-evaluation-object-identification/' + fitment.id)
          .then(response => {
            if (response && response.status === 200) {
              this.$router.push('/fitment/plus/complement/' + this.fitment.id);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    },

    addFitments() {
      let item = {
        //rowIndex: this.realEstate.buildings.length
      };
      this.fitment.evaluationFitments.push(item);
      //this.rowIndex++;
      // this.$router.push('/real-estate/building/new/' + this.realEstate.id);
    },
    showDeleteFitmentDialog(fitmentItem, index) {
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('messages.building.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
        // cancelButtonColor: '#dd3333'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('new-real-estate/building/' + fitmentItem.id)
              .then((res) => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('messages.building.deleteSuccess'),
                    type: 'success'
                  });
                  this.fitment.evaluationFitments.splice(index, 1);
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('messages.building.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        }
      });
    },

    onCategorySearch(searchTxt, loading) {
      loading(true);
      this.productCategoryFilter.search = searchTxt;
      this.searchMethodCategory(loading);
    },
    onCategoryFocus() {
      this.productCategoryFilter.search = '';
      this.searchMethodCategory();
    },
    searchMethodCategory(loading) {
      this.productCategories = [];
      this.productSubCategories = [];
      this.productCategoryFilter.objectId = this.fitment.id;
      this.$http.post('product-category-plus/search', this.productCategoryFilter).then(res => {
        if (loading)
          loading(false);
        this.productCategories = res.data.data;
      }, err => {
        console.log(err);
      });
    },

    onSubCategorySearch(searchTxt, loading, index) {
      if (!this.fitment.evaluationFitments[index].productCategoryPlusDto) {
        return;
      }
      loading(true);
      this.subCategoryFilter.search = searchTxt;
      this.subCategoryFilter.parentId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.searchMethodSubCategory(loading);
    },
    onSubCategoryFocus(index) {
      if (!this.fitment.evaluationFitments[index].productCategoryPlusDto) {
        return;
      }
      this.subCategoryFilter.search = '';
      this.subCategoryFilter.parentId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.searchMethodSubCategory();
    },
    searchMethodSubCategory(loading) {
      this.productSubCategories = [];
      this.$http.post('product-sub-category-plus/search', this.subCategoryFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.productSubCategories = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onChangeMethodSub(index) {
      if (this.fitment.evaluationFitments[index].productCategoryPlusDto.fitmentType) {
        this.fitment.evaluationFitments[index].fitmentType = this.fitment.evaluationFitments[index].productCategoryPlusDto.fitmentType;
        this.fitment.evaluationFitments[index].customsDuty = this.fitment.evaluationFitments[index].productCategoryPlusDto.customsDuty;
      }
    },

    onProductManufactureSearch(searchTxt, loading, index) {
      loading(true);
      this.productManufactureFilter.search = searchTxt;
      this.productManufactureFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.searchProductManufacture(loading);
    },

    onProductManufactureFocus(index) {
      this.productManufactureFilter.search = '';
      this.productManufactureFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.searchProductManufacture();
    },

    searchProductManufacture(loading) {
      this.manufactures = [];
      this.$http.post('product-manufacture/search', this.productManufactureFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.manufactures = res.data.data;
          }, err => {
            console.log(err);
          });
    },


    onProductModelSearch(searchTxt, loading, index) {
      loading(true);
      this.productModelFilter.search = searchTxt;

      this.productModelFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.evaluationFitments[index].productManufactureDto.id;

      this.searchProductModel(loading);
    },

    onProductModelFocus(index) {
      this.productModelFilter.search = '';
      this.productModelFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.evaluationFitments[index].productManufactureDto.id;
      this.searchProductModel();
    },

    searchProductModel(loading) {
      this.productModels = [];
      this.$http.post('product-model/search', this.productModelFilter)
          .then(res => {

            if (loading)
              loading(false);
            this.productModels = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    //
    //
    // onChangeMethodModal(index) {
    //
    //   console.log("this.fitment.evaluationFitments = ",  this.fitment.evaluationFitments);
    //   console.log("this.fitment.evaluationFitments[index].productModelDto = ",  this.fitment.evaluationFitments[index].productModelDto);
    //   if (this.fitment.evaluationFitments[index].productModelDto) {
    //     this.fitment.evaluationFitments[index].fitmentType = this.fitment.evaluationFitments[index].productModelDto.fitmentType.code;
    //   }
    // },


    onCountrySearch(searchTxt) {
      this.countryList = [];
      this.filter.search = searchTxt;
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCountryFocus() {
      this.countryList = [];
      this.filter.search = '';
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onChangeFilterProvince() {
      this.filter.provinceId = null
      if (this.province) {
        this.filter.provinceId = this.province.id
      }
    },
    onProvinceFocus() {
      this.provinces = [];
      this.filterProvince.search = '';
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onProvinceSearch(searchTxt, loading) {
      this.provinces = [];
      this.filterProvince.search = searchTxt;
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },

    //
    // unitMeasurementChange(data) {
    //   console.log("data = ", data);
    //   let um = "";
    //   if (data) {
    //     for (let i = 0; i < this.unitMeasurements.length; i++) {
    //       if (data.toLowerCase() === this.unitMeasurements[i].key.toLowerCase()) {
    //         um = this.unitMeasurements[i].name;
    //       }
    //     }
    //   }
    //   return um;
    // },
    //
    // saveItem(fitmentItem, index) {
    //
    //
    //   console.log("this.$v = ", this.$v);
    //   console.log("this.fitment.evaluationFitments[index] = ", this.fitment.evaluationFitments[index]);
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     return;
    //   }
    //   this.processing = true;
    //   this.$http.post('fitment/item/plus/save', this.fitment.evaluationFitments[index])
    //       .then(res => {
    //         if (res.data.status === 'SUCCESS') {
    //           this.$swal({
    //             title: this.$t('messages.common.warning'),
    //             text: this.$t(res.data.message),
    //             type: 'warning'
    //           });
    //         } else {
    //           this.$swal({
    //             title: this.$t('messages.common.warning'),
    //             text: this.$t(res.data.message),
    //             type: 'warning'
    //           });
    //         }
    //         this.processing = false;
    //       }, () => {
    //         this.$swal({
    //           title: this.$t('messages.common.error'),
    //           text: this.$t('messages.realEstate.error'),
    //           type: 'error'
    //         });
    //         this.processing = false;
    //       });
    // }


  },

  // watch: {
  //   fitment: {
  //     handler: function (val) {
  //       console.log("fitment = ", val)
  //     },
  //     deep: true
  //   }
  // },

  created() {
    this.init();
    this.getEvaluationRespectiveType();
    this.isRoleDirector();
    this.isRoleAppraiser();
  }
}
</script>

<style scoped>

</style>
